<!-- 培训项目列表 -->
<template>
  <div class="list">
    <div class="upgraded">
      <div class="title">
        <span>培训项目</span>
      </div>

      <ul>
        <li
          v-for="(item, index) in oneList"
          :key="index"
          @click="jumpD(item.id)"
        >
          <div class="li-div">
            <span class="li-left" :title="item.name">{{ item.name }}</span>
            <img src="./../../assets/16.png" alt="箭头" class="li-right" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getTrainList } from "@/api/home";
import { getActive, setActive, removeActive } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      page: 1,
      oneList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    jumpD(id) {
      this.$router.push({
        path: "/train/train-listd",
        query: {
          id: id,
        },
      });
      setActive("6-1");
      this.$store.dispatch("user/setActive", "6-1");
    },
    fetchData() {
      let params1 = {
        page: 1,
      };
      getTrainList(params1).then((response) => {
        this.oneList = response.data;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.list {
  padding-top: 45px;
  padding-bottom: 100px;
  .upgraded {
    margin-bottom: 55px;
    .title {
      width: 265px;
      height: 55px;
      background-color: #035bb2;
      line-height: 55px;
      text-align: center;
      font-size: 22px;
      color: #ffffff;
      @media screen and (max-width: 768px) {
        width: 190px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
      }
    }
    ul {
      width: 100%;
      margin-top: 20px;
      li {
        display: inline-block;
        padding-right: 10px;
        width: 25%;
        @media screen and (max-width: 768px) {
          width: 50%;
          font-size: 12px;
          padding: 0 5px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        height: 45px;
        margin-bottom: 10px;
        color: #484848;
        font-size: 16px;
        line-height: 45px;
        cursor: pointer;
        .li-div {
          background-color: #f4f4f4;
          height: 45px;
          max-width: 265px;
          width: 100%;
          padding: 0 15px;
        }
        .li-left {
          float: left;
          width: 70%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .li-right {
          float: right;
          width: 12px;
          height: 15px;
          margin-top: 15px;
        }
      }
    }
  }
}
</style>
